/* 分开之后得改路由，写全名，要不报错 */
import {
	formatDate
} from '../common/filters.js'
export default {
	name: '/manage/main.exam_result',
	filters: {
		formatDate(time) {
			var date = new Date(time)
			// console.log(date)
			return formatDate(date, 'yyyy-MM-dd hh:mm')
		}
	},
	data() {
		return {
			eScore: {
				sUserName: '',
				score: '',
				isPass: '',
				sidno: '',
				// distribute:'',
				ePaperName: '',
				paperId: '',
				pageNum: 1,
				size: 10,
				total: 0,
				rows: []
			},

			multipleSelection: [],

			checkResultDialogFormVisible: false,
			checkResultTable: {
				content: '',
				eqStem: '',
				eqAnswer: '',
				paperId: '',
				staffId: '',
				pageNum: 1,
				size: 10,
				total: 0,
				rows: []
			},

			intergralDialogFormVisible: false,
			intergralTable: {
				pageNum: 1,
				size: 10,
				total: 0,
				rows: []
			},
			intergralForm: {
				userName: '',
				mobile: ''
			},

			intergralRecordDialogFormVisible: false,
			intergralRecordTable: {
				pageNum: 1,
				size: 10,
				total: 0,
				rows: [],
				staffId: ''
			}
		}
	},
	mounted() {
		this.scoreList()
	},
	methods: {
		/* fenye(pageNum) {let size = this.size;var param = {sUserName: this.sUserName, //手机号isPass: this.isPass,ePaperName: this.ePaperName,sidno: this.sidno, // 姓名score: this.score,state: 2};this.$fenye('zhongljBack/mapi/Exam_Score/selectcount', 'zhongljBack/mapi/Exam_Score/selectall', param,pageNum, size, result => {this.eScore = result;// console.log(result)this.pageNum = result.pageNum;})}, */
		scoreList() {
			// var params = new URLSearchParams()
			// params.append('sUserName', this.eScore.sUserName)
			// params.append('score', this.eScore.score)
			// params.append('isPass', this.eScore.isPass)
			// params.append('ePaperName', this.eScore.ePaperName)
			// params.append('sidno', this.eScore.sidno)
			// params.append('pageNo', this.eScore.pageNum)
			// params.append('pageSize', this.eScore.size)
			// params.append('state', 2)
			let loading = this.$loading()
			let params = {
				'sUserName': this.eScore.sUserName,
				'score': this.eScore.score,
				'isPass': this.eScore.isPass,
				'ePaperName': this.eScore.ePaperName,
				'sidno': this.eScore.sidno,
				// 'distribute': this.eScore.distribute,
				'pageNo': this.eScore.pageNum,
				'pageSize': this.eScore.size,
				'state': 2,
				'gardenId':this.$store.getters.gardenId
			}
			this.$post('Exam_Score/selectall', params)
				.then(response => {
					// console.log(response)
					this.eScore.rows = response.list.rows
					this.eScore.total = response.list.total
					this.eScore.pageNum = response.list.page

					loading.close()
				})
				.catch(error => {
					this.$message.error(error)
					loading.close()
				})
		},
		handleCurrentChange(val) {
			this.scoreList()
		},
		handleSizeChange(val) {
			this.eScore.size = val
			this.scoreList()
		},
		handleSelectionChange(val) {
			this.multipleSelection = val
			// console.log(this.multipleSelection)
		},
		clear() {
			this.eScore.sUserName = ''
			this.eScore.isPass = ''
			this.eScore.sidno = ''
			// this.eScore.distribute = ''
			this.eScore.ePaperName = ''
			this.eScore.score = ''
		},
		select() {
			this.eScore.pageNum = 1
			this.scoreList()
		},
		check(row, pageNum) {
			this.checkResultTable.rows = []
			this.checkResultDialogFormVisible = true
			this.checkResultTable.paperId = row.paperId
			this.checkResultTable.staffId = row.staffId
			this.checkResultTable.id = row.id
			// console.log(row);
			// var params = new URLSearchParams();
			// params.append('paperId', row.paperId);
			// params.append('staffId', row.staffId);
			// params.append('scoreId', row.id);
			// params.append('pageNo', pageNum);
			// params.append('pageSize', this.checkResultTable.size);
			let loading = this.$loading()
			let params = {
				'paperId': row.paperId,
				'staffId': row.staffId,
				'scoreId': row.id,
				'pageNo': pageNum,
				'pageSize': this.checkResultTable.size
			}
			this.$post('Exam_Record/selectall', params)
				.then(response => {
					// console.log(response)
					this.checkResultTable.rows = response.list.rows
					this.checkResultTable.total = response.list.total
					this.checkResultTable.pageNum = response.list.page
					loading.close()
				})
				.catch(error => {
					this.$message.error(error)
					loading.close()
				})
		},
		checkResulthandleCurrentChange(val) {
			this.check(this.checkResultTable, val)
		},
		checkResulthandleSizeChange(val) {
			this.checkResultTable.size = val
			this.check(this.checkResultTable, this.checkResultTable.pageNum)
		},
		// 跳转BI
		seeRank() {
			// var url =
			// 	'https://bi.aliyuncs.com/token3rd/dashboard/view/pc.htm?pageId=03ecb969-95fa-40f6-80ad-60ec56687b4c&accessToken=5c0504f1cbad96e9a0d21d995e8d3040'
				var url =
				'https://bi.aliyuncs.com/token3rd/dashboard/view/pc.htm?pageId=03ecb969-95fa-40f6-80ad-60ec56687b4c&accessToken=0a3d2058a0746f78bd441213385db341&dd_orientation=auto'
			window.open(url, '_blank') // 新窗口打开外链接
		},

		seeIntergral() {
			this.intergralDialogFormVisible = true
			this.intergralTable.pageNum = 1
			this.selectIntergral(1)
		},
		// 查询总学分表
		selectIntergral(pageNum) {
			let loading = this.$loading()
			this.$get('Exam_Intergral/selectAll', {
					pageNo: pageNum,
					pageSize: this.intergralTable.size,
					sIdNo: this.intergralForm.userName,
					sUserName: this.intergralForm.mobile
				})
				.then(res => {
					this.intergralTable.total = res.total
					this.intergralTable.rows = res.list
					loading.close()
				})
				.catch(err => {
					this.$message.error(err)
					loading.close()
				})
		},
		intergralFormClear() {
			this.intergralForm = {}
		},

		intergralhandleCurrentChange(val) {
			this.selectIntergral(val)
		},
		intergralhandleSizeChange(val) {
			this.intergralTable.size = val
			this.selectIntergral(this.intergralTable.pageNum)
		},

		seeIntergralRecord(row) {
			console.log("点击了查看记录");
			this.intergralRecordDialogFormVisible = true
			this.intergralRecordTable.staffId = row.staffId
			this.intergralRecordTable.pageNum = 1
			this.selectIntergralRecord(1)
		},
		// 查询学分记录表
		selectIntergralRecord(pageNum) {
			let loading = this.$loading()
			this.$get('Exam_IntergralRecord/selectAll', {
					pageNo: pageNum,
					pageSize: this.intergralRecordTable.size,
					staffId: this.intergralRecordTable.staffId
				})
				.then(res => {
					console.log(res);
					this.intergralRecordTable.total = res.total
					this.intergralRecordTable.rows = res.list
					loading.close()
				})
				.catch(err => {
					this.$message.error(err)
					loading.close()
				})
		},
		intergralRecordhandleCurrentChange(val) {
			this.selectIntergralRecord(val)
		},
		intergralRecordhandleSizeChange(val) {
			this.intergralRecordTable.size = val
			this.selectIntergralRecord(this.intergralRecordTable.pageNum)
		},

		/* 错误的记录红色高亮 */
		tableRowClassName({
			row,
			rowIndex
		}) {
			// console.log(row)
			if (row.eqAnswer != row.content) {
				// console.log(this.checkResultTable.eqAnswer)
				return 'warning-row'
			}
			return ''
		}
	}
}
